export default function interactiveMap() {
  const container = document.querySelector('.js-imap-container');
  if (! container) return;

  const groups = container.querySelectorAll('.js-imap-group');
  if (! groups) return;
  // console.log(groups);

  const svg = container.querySelector('.js-imap-svg');
  const paths = svg.querySelectorAll('path');
  if (! paths) return;

  let doOnce = true;

  paths.forEach(path => {
      path.classList.add('imap__map__item');

      groups.forEach(group => {
          if (path.dataset.name === group.dataset.name) {
              if (doOnce) {
                  path.classList.add('is-active');
                  group.classList.add('is-active');
                  doOnce = false;
              }
              path.classList.add('is-interactive');
              // path.tabIndex = '0';
              // path.title = group.dataset.label;

              path.addEventListener('click', event => {
                  // console.log(`${path.dataset.name} clicked`);
                  closeAll();
                  path.classList.add('is-active');
                  group.classList.add('is-active');
                  group.scrollIntoView({block: 'center'});
              });
          }
      });
  });

  function closeAll() {
      paths.forEach(path => {
          path.classList.remove('is-active');
      });
      groups.forEach(group => {
          group.classList.remove('is-active');
      });
  }
}
